/**
 * Returns true if the rental range [startStr, endStr] (YYYY-MM-DD) overlaps
 * with any unavailability record.
 *
 * type "0" = weekly recurring (WeekDAY: 0=Mon … 6=Sun in app convention)
 * type "1" = custom date range (start_date / end_date)
 */
export function isOverlapWithUnavailabilities(unavailabilities, startStr, endStr) {
  if (!startStr || !endStr || !Array.isArray(unavailabilities) || unavailabilities.length === 0)
    return false;

  for (const u of unavailabilities) {
    if (u.type === '1') {
      // Custom range: overlap ↔ start_date ≤ endStr && end_date ≥ startStr
      if (u.start_date <= endStr && u.end_date >= startStr) return true;
    } else if (u.type === '0') {
      // Weekly recurring: scan each day in the range for that weekday
      const targetWeekday = parseInt(u.WeekDAY, 10); // 0=Mon … 6=Sun
      // Use noon (T12:00:00) to avoid DST edge-cases
      const cur = new Date(startStr + 'T12:00:00');
      const end = new Date(endStr + 'T12:00:00');
      while (cur <= end) {
        const jsDay = cur.getDay(); // 0=Sun … 6=Sat
        const appDay = jsDay === 0 ? 6 : jsDay - 1; // 0=Mon … 6=Sun
        if (appDay === targetWeekday) return true;
        cur.setDate(cur.getDate() + 1);
      }
    }
  }
  return false;
}

/**
 * Returns true if a single date string (YYYY-MM-DD) is blocked by any
 * unavailability record. Used for shouldDisableDate in the picker.
 */
export function isDateUnavailable(unavailabilities, dateStr) {
  if (!dateStr || !Array.isArray(unavailabilities)) return false;
  return isOverlapWithUnavailabilities(unavailabilities, dateStr, dateStr);
}
